import type { CardArtAssetName } from '../../../shared/types'
import {
  GOLD_LINE_INVITE_CODE,
  GREEN_LINE_INVITE_CODE,
  SECURED_CARD_INVITE_CODE,
  SILVER_LINE_INVITE_CODE,
} from '../../../constants/inviteCodes'

export const TERMS_PATH = '/legal/cardholder-agreements'

export const cardProducts = [
  {
    header: 'Best for good credit',
    cardArt: 'goldlineV0' as CardArtAssetName,
    productName: 'Gold Line',
    description:
      'Earn unlimited 3% cash back on gas, travel, and dining, plus 1% on all other purchases.',
    valueProps: [
      { key: 'Starting Credit Line', value: 'Up to $3,000' },
      { key: 'Cash Back on Gas, Travel, Dining', value: '3%' },
      { key: 'Cash Back on All Other Purchases', value: '1%' },
      { key: 'Annual Fee', value: '$0' },
    ],
    ctaName: `Gold Line`,
    inviteCode: GOLD_LINE_INVITE_CODE,
    termsPath: TERMS_PATH,
    learnMorePath: '/credit-cards/gold-line-visa',
  },
  {
    header: 'Best for good credit',
    cardArt: 'silverlineV0' as CardArtAssetName,
    productName: 'Silver Line',
    description: 'Earn unlimited 1.5% cash back on every purchase, with no cap on your rewards.',
    valueProps: [
      { key: 'Starting Credit Line', value: 'Up to $3,000' },
      { key: 'Cash Back on All Purchases', value: '1.5%' },
      { key: 'Annual Fee', value: '$0' },
    ],
    ctaName: `Silver Line`,
    inviteCode: SILVER_LINE_INVITE_CODE,
    termsPath: TERMS_PATH,
    learnMorePath: '/credit-cards/silver-line-visa',
  },
  {
    header: 'Best for fair-to-good credit',
    productName: 'Green Line',
    description: 'Move forward with confidence with a card designed to grow with you.',
    valueProps: [
      { key: 'Starting Credit Line', value: 'Up to $2,000' },
      { key: 'Security Deposit', value: 'None' },
    ],
    ctaName: `Green Line`,
    inviteCode: GREEN_LINE_INVITE_CODE,
    learnMorePath: '/credit-cards/green-line-visa',
  },
  {
    header: 'Best for establishing credit',
    productName: 'Secured',
    description: 'Start building your future with a card made to put progress within reach.',
    valueProps: [
      { key: 'Starting Credit Line', value: 'Up to $1,000' },
      { key: 'Security Deposit', value: 'Refundable' },
    ],
    ctaName: `Secured Card`,
    inviteCode: SECURED_CARD_INVITE_CODE,
    learnMorePath: '/credit-cards/secured-visa',
  },
]
